import React from 'react'
import CarouselComponent from './CarouselComponent'
import "./LandingPage.css"

const LandingPage = () => {
    return (
        <div className='carousel-container'>
            <CarouselComponent />
        </div>
    ) 
}

export default LandingPage